import { createElement } from 'react';
import PropTypes from 'prop-types';

const Component = ({ as, children, ...props }) => {
  return createElement(as, props, children);
};

Component.propTypes = {
  as: PropTypes.node.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

Component.defaultProps = {
  as: 'div',
};

export default Component;
